import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { getValidTransitions, getStatusLabel, isTerminalStatus } from "@/lib/status-machine";
import type { ObjectiveStatus } from "@/types/entities";

interface StatusTransitionSelectProps {
  currentStatus: ObjectiveStatus;
  onTransition: (newStatus: ObjectiveStatus) => void;
  disabled?: boolean;
  /**
   * When false (default), `draft` is filtered out of the rendered options so
   * users without revert permission don't see an action they can't perform.
   */
  canRevertToDraft?: boolean;
}

export function StatusTransitionSelect({
  currentStatus,
  onTransition,
  disabled,
  canRevertToDraft = false,
}: StatusTransitionSelectProps) {
  const allTransitions = getValidTransitions(currentStatus);
  const validTransitions = canRevertToDraft
    ? allTransitions
    : allTransitions.filter((s) => s !== "draft");

  if (isTerminalStatus(currentStatus) || validTransitions.length === 0) {
    return null;
  }

  return (
    <Select
      onValueChange={(value) => onTransition(value as ObjectiveStatus)}
      disabled={disabled}
    >
      <SelectTrigger className="w-48">
        <SelectValue placeholder="Transition to..." />
      </SelectTrigger>
      <SelectContent>
        {validTransitions.map((status) => (
          <SelectItem key={status} value={status}>
            {getStatusLabel(status)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
